import React from 'react';
import { css, keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, AllProps } from 'localmed-core';
import tinycolor from 'tinycolor2';

const shimmer = keyframes`
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
`;

const StyledSkeleton = styled(Box)(
  ({ theme, circle, dark }: any) => {
    const baseColor = dark
      ? tinycolor(theme.colors.darkBlue).lighten(6).toHexString()
      : theme.colors.borderColor;
    return css`
      display: block;
      background-color: ${baseColor};
      border-radius: ${circle ? '50%' : theme.radii.md};
    `;
  },
  ({ theme, inactive, dark }) => {
    const baseColor = dark
      ? tinycolor(theme.colors.darkBlue).lighten(6).toHexString()
      : theme.colors.borderColor;
    if (inactive !== true) {
      return css`
        animation-duration: 2.5s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: ${shimmer};
        animation-timing-function: linear;
        background: linear-gradient(
          90deg,
          ${baseColor} 0%,
          ${tinycolor(baseColor).darken(4).toHexString()} 15%,
          ${baseColor} 30%
        );
        background-size: 1200px 100%;
      `;
    }
    return null;
  }
);

type Props = AllProps & {
  inactive?: boolean;
  circle?: boolean;
  dark?: boolean;
};

export default function Skeleton(props: Props) {
  return (
    <StyledSkeleton as="span" {...props}>
      &nbsp;
    </StyledSkeleton>
  );
}
